import { ProductPanelScrollMarker } from '@Components/ProductDetailPanel/product-panel-scroll-marker';
import { useScreenSize } from '@Hooks/useScreenSize';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';

import StyledProductCard from '../StyledProductCard';
import ProductDescription from './ProductDescription';

import { useProductsStore } from '~stores/products';
import { ProductPanelMarkers, ScreenSize } from '~types/views-types';

type IStyledProductDescriptionWrapperProps = {
  bottomPadding: boolean;
};

const StyledProductDescriptionCardWrapper = styled(StyledProductCard)`
  display: flex;
  flex-flow: column nowrap;
  padding-bottom: ${(props: IStyledProductDescriptionWrapperProps) =>
    props.bottomPadding ? '120px' : '16px'};
`;

const ProductDescriptionCard: FC = () => {
  const { currentProduct } = useProductsStore();
  const [size] = useScreenSize();

  if (!currentProduct) {
    return null;
  }

  return (
    <>
      <ProductPanelScrollMarker id={ProductPanelMarkers.ProductDescription} />
      <StyledProductDescriptionCardWrapper
        bottomPadding={[
          ScreenSize.mobile,
          ScreenSize.thinmobile,
          ScreenSize.tabletPortrait,
        ].includes(size)}
      >
        <ProductDescription html={currentProduct.description} />
      </StyledProductDescriptionCardWrapper>
    </>
  );
};

export default observer(ProductDescriptionCard);
